import {AfterViewInit, ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
    AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators
} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {Router} from '@angular/router';
import {AccessService} from '../../../../core/services/access.service';
import {FillingMethodComponent} from '../filling-method/filling-method.component';

export function validateCustomObject(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: FillingMethodValue | null = control.value;

    // Проверяем, что объект существует и имеет нужную структуру
    if (!value || typeof value !== 'object') {
      return { invalidStructure: true };
    }

    const { fillType, unit, indexItems } = value;

    // Проверка каждого поля на заполненность
    const errors: ValidationErrors = {};

    const ifNumericParam = (): ValidationErrors | null => {
      if(!unit){
        errors['missingUnit'] = true;
        return errors;
      }else {
        return null;
      }
    }

    const mapCondition = {
      'List_Select': (): ValidationErrors | null => {
        if(!indexItems
            || (!Array.isArray(indexItems) || indexItems.length === 0)
            || indexItems.every(item => item.noViolations === undefined)
            || indexItems.every(item => item.noViolations === false)
        ){
          errors['missingListSelect'] = true;
          return errors;
        } else {
          return null;
        }
      },
      'Number_Enter': ifNumericParam,
      'Ias_Sport': ifNumericParam
    }

    return mapCondition[fillType]()

  };
}


@Component({
  standalone: true,
  selector: 'pas-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
    imports: [FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatIcon, MatIconButton, FillingMethodComponent, MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent implements AfterViewInit {

  isNew: boolean = false;

  form = new FormGroup({
    name: new FormControl<string>('',[Validators.required]),
    shortName: new FormControl<string>('',[Validators.required]),
    fillValue: new FormControl<FillingMethodValue | null>(null, [Validators.required, validateCustomObject()]),
  })
  isEnabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    public accessService: AccessService,
    private router: Router
  ) {
    this.isNew = data['isNew'];
    console.log('data',data);
    this.form.statusChanges.subscribe(value => {
      console.log('form',value)
    })
    this.form.get('fillValue')!.valueChanges.subscribe(value => {
      console.log('fillValue',value)
      this.form.updateValueAndValidity()
    })
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  private initSelectors(): void {
    this.form.get('name')!.setValue(this.data['name']);
    this.form.get('shortName')!.setValue(this.data['shortName']);
    this.form.get('fillValue')!.setValue({
      fillType: this.data['fillType'],
      unit: this.data['unit'],
      indexItems: this.data['indexItems'],
    });

    this.form.get('name')!.valueChanges.subscribe(v => {
      console.log(v);
    });
    this.form.get('shortName')!.valueChanges.subscribe(v => {
      console.log(v);
    });
    this.form.get('fillValue')!.valueChanges.subscribe(v => {
      console.log(v);
    });
  }


  onApply() {
    if(this.form.invalid) return;
    const returnData: IndexEntry = {
      id: 0,
      name: this.form.get('name')!.value || '',
      shortName: this.form.get('shortName')!.value || '',
      status: this.data['status'],
      ...this.form.get('fillValue')!.value || {},
    }
    this.dialogRef.close(returnData);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initSelectors();
    })
  }
}

